import { SelectionModel } from '@angular/cdk/collections';

export class TableItem<T> {
  item: T;
  cache = new Map<string, any>();

  constructor(item: T) {
    this.item = item;
  }
}

export class TableData<T> {
  total: number;
  items: Array<TableItem<T>>;
  selection = new SelectionModel<TableItem<T>>(true, new Array<TableItem<T>>());

  constructor(total: number, items: Array<T>) {
    this.total = total;
    this.items = items.map((x) => new TableItem<T>(x));
  }

  someSelected() {
    return !this.selection.isEmpty() && this.selection.selected.length < this.items.length;
  }

  eachSelected() {
    return !this.selection.isEmpty() && this.selection.selected.length === this.items.length;
  }

  toggle() {
    this.eachSelected() ? this.selection.clear() : this.items.forEach((row) => this.selection.select(row));
  }

  select(row: TableItem<T>) {
    this.selection.clear();
    this.selection.select(row);
  }

  saveSelection(storage: Array<string>, cb: (_: T) => string) {
    storage.length = 0;
    this.selection.selected.forEach((row) => storage.push(cb(row.item)));
  }

  loadSelection(storage: Array<string>, cb: (_: T) => string) {
    let storage_ = [...storage];
    storage.length = 0;
    this.selection.clear();
    this.items.forEach((row) => {
      if (storage_.includes(cb(row.item))) {
        storage.push(cb(row.item));
        this.selection.select(row);
      }
    });
  }
}

export class TableOptions {
  cortege: string = '';
  sortArg: string = '';
  sortDir: 'asc' | 'desc' | '' = '';
  pageIndex: number = 0;
  pageSize: number = 10;

  public copy(): TableOptions {
    const res = new TableOptions();
    res.cortege = this.cortege;
    res.sortArg = this.sortArg;
    res.sortDir = this.sortDir;
    res.pageIndex = this.pageIndex;
    res.pageSize = this.pageSize;
    return res;
  }

  private static convertPath(path: string): string {
    return path.startsWith('.') ? path.substr(1) : 'features.' + path;
  }

  toFilter(selectorsArray?: any[]): any {
    const selectors: any = {};
    if (selectorsArray) {
      selectorsArray.forEach((x) => {
        selectors[TableOptions.convertPath(x.fieldPath)] = { val: x.value, opt: x.option };
      });
    }
    let orders: any;
    if (this.sortArg && this.sortDir) {
      orders = {
        ordering: [
          {
            path: TableOptions.convertPath(this.sortArg),
            direction: this.sortDir.toUpperCase(),
          },
        ],
      };
    }
    return {
      limits: {
        offset: this.pageIndex * this.pageSize,
        count: this.pageSize,
      },
      orders: orders,
      selectors: selectors,
    };
  }
}
